import { useState } from "react";
import { useNavigate } from "react-router-dom";
import { api } from "../lib/api";
import { toast } from "sonner";
import { Lock } from "lucide-react";

export default function AdminLogin() {
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [loading, setLoading] = useState(false);
  const navigate = useNavigate();

  const submit = async (e) => {
    e.preventDefault();
    setLoading(true);
    try {
      const r = await api.post("/auth/login", { email, password });
      localStorage.setItem("admin_token", r.data.access_token);
      toast.success("Welcome back");
      navigate("/admin");
    } catch (e) {
      toast.error("Invalid credentials");
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="min-h-screen bg-[#F5F2EB] flex items-center justify-center px-6">
      <form
        onSubmit={submit}
        data-testid="admin-login-form"
        className="max-w-md w-full bg-white rounded-3xl p-10 border border-[#E9E2D3] shadow-sm"
      >
        <div className="w-12 h-12 rounded-full bg-[#1A2B4C] text-white flex items-center justify-center mb-6">
          <Lock className="w-5 h-5" />
        </div>
        <h1 className="font-serif text-3xl text-[#1A2B4C] mb-1">Admin Login</h1>
        <p className="text-sm text-gray-500 mb-8">Sithonia Holidays Dashboard</p>

        <label className="text-xs uppercase tracking-widest text-[#6B705C] mb-1.5 block">Email</label>
        <input
          type="email"
          value={email}
          onChange={(e) => setEmail(e.target.value)}
          data-testid="admin-email"
          className="w-full bg-[#F5F2EB] border border-[#E9E2D3] rounded-xl px-4 py-3.5 text-[#1A2B4C] focus:outline-none focus:ring-2 focus:ring-[#1A2B4C]/30 mb-4"
          required
        />

        <label className="text-xs uppercase tracking-widest text-[#6B705C] mb-1.5 block">Password</label>
        <input
          type="password"
          value={password}
          onChange={(e) => setPassword(e.target.value)}
          data-testid="admin-password"
          className="w-full bg-[#F5F2EB] border border-[#E9E2D3] rounded-xl px-4 py-3.5 text-[#1A2B4C] focus:outline-none focus:ring-2 focus:ring-[#1A2B4C]/30 mb-6"
          required
        />

        <button
          type="submit"
          disabled={loading}
          data-testid="admin-login-btn"
          className="w-full bg-[#1A2B4C] text-white py-3.5 rounded-full text-sm uppercase tracking-widest hover:-translate-y-0.5 transition-transform disabled:opacity-50"
        >
          {loading ? "..." : "Sign In"}
        </button>
      </form>
    </div>
  );
}
